import axiosInstance from './axiosInstance';

const emailService = {
  getInboxEmails: async (inbox, query) => {
    try {
      const response = await axiosInstance.post('/email/emails', {inbox:inbox, query: query});
      return response.data.emails;
    } catch (error) {
      console.error('Error getting inbox', error.response?.data || error.message);
      throw error;
    }
  },
  draftResponse: async (threadId) => {
    try {
      const response = await axiosInstance.post('/email/draft-response', {thread_id: threadId});
      return response.data.response;
    } catch (error) {
      console.error('Error drafting response', error.response?.data || error.message);
      throw error;
    }
  },
};

export default emailService;
